// extracted by mini-css-extract-plugin
export default {"layout":"a3def08fa5 _31ca029cca _2c2731165e","h_slide":"_66a39e416c","category":"_7489ae163c _35289d45c6 _0b7b15a85e"};